import {Modal, Paper, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 600,
    maxWidth: "100%",
    margin: 'auto',
  },
  paper: {
    padding: 24,
    margin: 32,
    maxHeight: '90%',
    overflow: 'scroll',
    [theme.breakpoints.down('xs')]: {
      margin: 10
    },
  }
}));

export const LotuModal = ({open, onClose, title, children}) => {
  const classes = useStyles();
  return (
    <Modal open={open} onClose={onClose} className={classes.root} aria-labelledby="modal-title">
      <Paper className={classes.paper}>
        <Typography component="h2" variant="h6">{title}</Typography>
        <div>{children}</div>
      </Paper>
    </Modal>
  )
};
